import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
// services
import { UpdateWorkerService } from './services/update-worker.service';
import { RouterOutlet } from '@angular/router';
import { SurveyService } from './services/survey.service';
import { WidgetHeaderComponent } from './shared/components/widget-header/widget-header.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, WidgetHeaderComponent]
})
export class AppComponent {

  constructor(@Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private updateWorkerService: UpdateWorkerService,
    public  surveyService: SurveyService
  ) {
    this.updateWorkerService
  }
  /**
   * set a random background for body element
   */
  setRandomBackground() {
    this.renderer.addClass(this.document.body, 'background-' + Math.floor(Math.random() * 13 + 1).toString());
  }

}
